export default __webpack_public_path__ + "static/media/customer.05d782fb.svg";